const hasUnsafeCharacters = (value) =>
  Array.from(value).some(
    (character) =>
      character === "\\" ||
      character.charCodeAt(0) < 32 ||
      character.charCodeAt(0) === 127,
  );

// Return targets come from URL query parameters, so accept only local paths.
export function localReturnPath(value, fallback = "/") {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    hasUnsafeCharacters(value)
  ) {
    return fallback;
  }
  try {
    const decoded = decodeURIComponent(value);
    if (decoded.startsWith("//") || hasUnsafeCharacters(decoded)) {
      return fallback;
    }
    const target = new URL(value, window.location.origin);
    const decodedTarget = new URL(decoded, window.location.origin);
    if (
      target.origin !== window.location.origin ||
      decodedTarget.origin !== window.location.origin ||
      target.pathname.startsWith("//") ||
      decodedTarget.pathname.startsWith("//")
    )
      return fallback;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return fallback;
  }
}
